import { ApiService } from '../../services/api/api.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';

import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { AppMaterialComponentsModule } from '../app-material-components/app-material-components.module';
import { MatIconModule } from '@angular/material/icon';

import { TrainingApiService } from '../../services/data/training-api.service';
import { TrainingGqlService } from '../../services/data/dynamics/training-gql.service';

import { TrainingComponent } from './components/training.component';
import { VideoModalDialogComponent } from './components/video-modal-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { quizService } from '../../services/quiz/quiz.service';
@NgModule({
  declarations: [
    TrainingComponent,
    VideoModalDialogComponent,
    
    
    
  ],
  exports: [
    TrainingComponent,
    VideoModalDialogComponent,
    
    
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppMaterialComponentsModule,
    FlexModule,
    FlexLayoutModule,
    MatIconModule,
    NgxTrimDirectiveModule,
    BrowserModule,
    MatDialogModule
    
  ],
  providers: [
    ApiService,quizService,
    { provide: TrainingApiService, useClass: TrainingGqlService },
  ],
  
})
export class TraininghModule { }
